import http from './http' // needs this file in the same directory
import {The_Ability} from '../store/index'

export default {
  indexEmployee(filter){
    return http.get(`/employees`, { params: {...filter } } );
  },

  index(filter){
    return http.get(`/users`, { params: {...filter } } );
  },

  show(item_id){
    return http.get(`/users/`+item_id);
  },

  profile(item_id){
    return http.get(`/users/profile/`);
  },

  create(new_item){
    // if (The_Ability.can('create', 'User')){
      return http.post(`/users`,{
        user:{ 
          name: new_item.name,
          email: new_item.email,
          cpf: new_item.cpf,
          confirmed_at: new Date(),
          // password: 123456, // new_item.password,
          // password_confirmation: 123456, //new_item.password_confirmation,
          role_ids: [new_item.role_ids],

          needs_to_deactivate: new_item.needs_to_deactivate,
          deactivate_at: new_item.deactivate_at,
          deactivation_time_in_sec: new_item.deactivation_time_in_sec,

          employee_attributes: new_item.employee_attributes
        }
      });
    // } else {
      // return false
    // }
  },

  update(update_item){
    return http.put(`/users/${update_item.id}`,{
      user:{ 
        id: update_item.id,

        name: update_item.name,
        email: update_item.email,
        cpf: update_item.cpf,
        current_password: update_item.current_password,
        password: update_item.password,
        password_confirmation: update_item.password_confirmation,
        role_ids: [update_item.role_ids],
        removed_departments: update_item.removed_departments,

        needs_to_deactivate: update_item.needs_to_deactivate,
        deactivate_at: update_item.deactivate_at,
        deactivation_time_in_sec: update_item.deactivation_time_in_sec,

        employee_attributes: update_item.employee_attributes

      }
    });
  },

  updateToDelete(update_item){
    return http.delete(`/users/${update_item}`);
  },

  delete(user) {
    return http.delete(`/users/${user.id}`);
  },

  restore(user) {
    return http.put(`/users/${user.id}/restore`)
  },
  reactivate(user) {
    return http.put(`/users/${user.id}/reactivate`)
  },
  deactivate(user) {
    return http.put(`/users/${user.id}/deactivate`)
  },

  showDeletedBy(model, model_id) {
    return http.get(`/users/deleted_by`, {
      params: {
        model,
        model_id
      }
    })
  }
}
